import React from 'react';
import { ShieldAlert, MonitorX, Check, AlertTriangle } from 'lucide-react';
import { useIPTV } from '../../context/IPTVContext';

export const ScreenKickedModal: React.FC = () => {
  const { screenKickedNotice, dismissScreenKickedNotice } = useIPTV();

  if (!screenKickedNotice || !screenKickedNotice.visible) return null;

  const kickerName = screenKickedNotice.byProfile || 'outro perfil';

  return (
    <div className="fixed inset-0 z-[999999] flex items-center justify-center p-4 bg-black/90 backdrop-blur-2xl animate-in fade-in duration-200 select-none">
      <div className="relative w-full max-w-md max-h-[85vh] overflow-y-auto bg-zinc-950 border border-amber-500/40 rounded-3xl p-4 sm:p-6 md:p-8 shadow-2xl shadow-amber-950/50 space-y-6 text-center">
        {/* Glow Effect */}
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-64 h-64 bg-amber-500/15 rounded-full blur-3xl pointer-events-none" />

        {/* Icon */}
        <div className="relative mx-auto w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-400 shadow-xl shadow-amber-500/10">
          <MonitorX className="w-8 h-8 animate-pulse" />
          <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-amber-500 text-black font-black text-[11px] flex items-center justify-center shadow">
            !
          </span>
        </div>

        {/* Header */}
        <div className="space-y-2">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-300 text-xs font-black uppercase tracking-wider">
            <ShieldAlert className="w-3.5 h-3.5" />
            <span>Limite de Telas</span>
          </div>
          <h2 className="text-xl md:text-2xl font-black text-white tracking-wide">
            Reprodução Interrompida
          </h2>
        </div>

        {/* Message Card */}
        <div className="bg-zinc-900/90 border border-zinc-800 rounded-2xl p-4 text-left space-y-2.5 shadow-inner">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
            <div className="text-sm text-zinc-200 leading-relaxed font-medium">
              Seu perfil foi desconectado por{' '}
              <span className="text-amber-400 font-bold underline decoration-amber-500/50 underline-offset-2">
                {kickerName}
              </span>{' '}
              devido ter excedido o número de telas simultâneas da conta.
            </div>
          </div>

          <div className="text-[11px] text-zinc-400 pl-8 leading-normal border-t border-zinc-800/80 pt-2">
            Cada conta possui um limite máximo de aparelhos assistindo ao mesmo tempo. Você pode continuar navegando no catálogo normalmente.
          </div>
        </div>

        {/* Action Button */}
        <div className="pt-2">
          <button
            type="button"
            onClick={dismissScreenKickedNotice}
            className="w-full py-3.5 px-4 rounded-xl bg-amber-500 hover:bg-amber-400 active:scale-98 text-black font-black text-xs transition flex items-center justify-center gap-2 cursor-pointer shadow-lg shadow-amber-950/40"
          >
            <Check className="w-4 h-4 stroke-[3]" />
            <span>OK, Entendi</span>
          </button>
        </div>
      </div>
    </div>
  );
};
